import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatDate, formatToZMW, rootUrl } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import { useOutletContext } from "react-router-dom";
import { FaSpinner, FaBalanceScale, FaCalendarAlt, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { toast } from "react-toastify";

export default function TrialBalance({rdata, startDate, endDate}) {
  const [trialBalanceData, setTrialBalanceData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [loading, setLoading] = useState(true)
  const auth = useAuth();
  const {allData, setAllData} = useOutletContext();
  const fetchData = async () => {
      processTrialBalanceData(rdata);
  };

  

  const processTrialBalanceData = (response) => {
    const trialData = [];
    const processedCoas = new Map();
    let totalDebits = 0;
    let totalCredits = 0;

    const totalBills = sumArray(response.bills.map((res) => parseFloat(res.amount)));
    const totalCred = sumArray(response.supplier.filter((a) => a.type == 1 && a.expense == "None").map((res) => parseFloat(res.amount)));

    // response.bills.forEach((res) => {
    //   const coa = allData.budget?.find(item => item.id === res.coa_id);
    //   // const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === coa.id).map((r) => parseFloat(r.amount)));
    //   // const toCoa = sumArray(response.journal.filter((a) => a.to_coa === coa.id).map((r) => parseFloat(r.amount)));
    //   const credit = parseFloat(res.amount) 
    //   // - fromCoa + toCoa;
    //   const debit = 0;
    //   trialData.push({ code: coa.coa, desc: allData.coa?.find(item => item.account === coa.coa)?.name, debit, credit });
    //   totalCredits += credit;
    // });


    let loan = 0.0

    response.bills.forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa_id);
      if (!coa) return;
    
      const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === coa.id).map((r) => parseFloat(r.amount)));
      const toCoa = sumArray(response.journal.filter((a) => a.to_coa === coa.id).map((r) => parseFloat(r.amount)));
      let amount = 0.0
      if(coa.coa == "157004"){
        loan = res.amount - parseFloat(res.amount) * 0.05;
        amount = parseFloat(res.amount) * 0.05;
      }else{
        amount = parseFloat(res.amount)
      }

      const credit = parseFloat(amount) - fromCoa + toCoa;
      const debit = 0;
      const coaCode = coa.coa;
      const desc = allData.coa?.find(item => item.account === coa.coa)?.name || 'Unknown';
    
      

      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        existing.credit += credit;
      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
      totalCredits += credit;
    });
    
    
    response.journal.forEach((journalEntry) => {
      
      // const boz = response.bills?.find(item => item.coa_id === journalEntry.to_coa);
      // const  soz = response.supplier.filter((a) => a.type == 1)?.find(item => item.coa === journalEntry.to_coa);
      // if (boz || soz ) return; 
        const coaCode = allData.budget?.find(item => item.id === journalEntry.to_coa)?.coa;
        const amount = parseFloat(journalEntry.amount);
        const desc = allData.coa?.find(item => item.account === coaCode)?.name || 'Unknown';
   
        let credit =0 
        let debit =0 
    
          if(coaCode == '326040'){

          }else{
       
            credit = coaCode[0] == "1" ? amount : 0;
            debit = coaCode[0] == "1" ? 0 : amount;
  
            if (credit !== 0) {
              totalCredits += amount;
            } else {
              totalDebits += amount;
            }
    

            if (processedCoas.has(coaCode)) {
              let existing = processedCoas.get(coaCode);
              existing.credit += credit;
              existing.debit += debit;
            } else {
              processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
            }
          }
        
       
      
      
    });
    
    
    response.supplier.filter((a) => a.type == 1 && a.expense == 'None').forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa);
      if (!coa) return; 
    
      const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === coa.id).map((r) => parseFloat(r.amount)));
      const toCoa = sumArray(response.journal.filter((a) => a.to_coa === coa.id).map((r) => parseFloat(r.amount)));
      let amount = 0.0
      if(coa.coa == "321040"){
        amount = parseFloat(res.amount) - loan;
      }else{
        amount = parseFloat(res.amount)
      }
      const debit = parseFloat(amount) - fromCoa + toCoa;
      const credit = 0;
      const coaCode = coa.coa;
      const desc = allData.coa?.find(item => item.account === coa.coa)?.name || 'Unknown';
      

     

      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        existing.debit += debit;

      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
    
      totalDebits += debit;
    });
    
    // trialData.push(...processedCoas.values());

    trialData.push({
      code: "321030",
      desc: "Debtors Control Account",
      debit: totalBills - response.recs[0]?.amount || 0,
      credit: 0,
    });
  
    
    totalDebits += totalBills - response.recs[0]?.amount || 0;

    trialData.push({
      code: "326040",
      desc: "Bank Balances",
      debit: parseFloat(response.cash[0]?.difference) + sumArray(response.opening.filter(a=>a.type == 'Cashbook').map((res) => parseFloat(res.amount))) || 0,
      credit: 0,
    });
    totalDebits += parseFloat(response.cash[0]?.difference) || 0;

    let done = []

    response.supplier.filter((a) => a.expense !== 'None' && a.type == 1).forEach((res) => {

      const coa = res.expense;
      if (!coa) return; 
      const coaCode = coa;
      const isz = allData.budget?.find(item => item.coa === coa)?.id
      const fromCoa = sumArray(response.journal.filter((a) => a.from_coa === isz).map((r) => parseFloat(r.amount)));
      const toCoa = sumArray(response.journal.filter((a) => a.to_coa === isz).map((r) => parseFloat(r.amount)));
      
      
      let amu = 0
      if(done.includes(coa)){
        amu = parseFloat(res.amount)
      }else{
        amu = parseFloat(res.amount) - fromCoa + toCoa
      }
      done.push(coa)
     

      const credit = coaCode == '322020' || coaCode == '322070'?0:parseFloat(amu)
      const debit = coaCode == '322020' ||coaCode == '322070'?parseFloat(amu):0;

      const desc = allData.coa?.find(item => item.account === coa)?.name || 'Unknown';
      
      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        existing.credit += credit;
        existing.debit += debit;

      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
    
      totalCredits += credit;
      totalDebits += debit;
    });
    

    response.debt.forEach((res) => {
      const coa = allData.budget?.find(item => item.id === res.coa);
      if (!coa) return; 
    
      const credit = parseFloat(res.amount)
      const debit = 0;
      const coaCode = coa.coa;
      const desc = allData.coa?.find(item => item.account === coa.coa)?.name || 'Unknown';

      

      if (processedCoas.has(coaCode)) {
        let existing = processedCoas.get(coaCode);
        
        if(res.type == 1){
          existing.credit += credit;
        }else{
          existing.credit -= credit;
        }
        
      } else {
        processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
      }
    
      if(res.type == 1){
        totalCredits += credit;
      }else{
        totalCredits -= credit;
      }
    });
    

    response.opening.forEach((res) => {

      if(res.type == 'COA'){
        const debit = parseFloat(res.amount)
        const credit = 0;
        const coaCode = res.fkey;
        const desc = allData.coa?.find(item => item.account === res.fkey)?.name || 'Unknown';
        
        
        if (processedCoas.has(coaCode)) {
          let existing = processedCoas.get(coaCode);
          // if(res.type == 1){
            existing.debit -= debit;
          // }else{
            // existing.credit -= credit;
          // }        
        } else {
          
          processedCoas.set(coaCode, { code: coaCode, desc, debit, credit });
        }
          totalCredits += credit;
      }else{

      }
      
    
     
      
    });


    trialData.push(...processedCoas.values());

    // trialData.push({
    //   code: coaCode,
    //   desc: desc,
    //   credit: credit,
    //   debit: debit,
    // });

    
    

    trialData.push({
      code: "510010",
      desc: "Accumulated Fund",
      credit: 0,
      debit: sumArray(response.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))) + 
      sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 4).map((res) => parseFloat(res.amount))) - sumArray(response.opening.filter(a=>a.type == 'Cashbook').map((res) => parseFloat(res.amount)))
      - sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 3).map((res) => parseFloat(res.amount))) ,
    });
    totalDebits += sumArray(response.debt.filter(a=>a.type == 1).map((res) => parseFloat(res.amount))) + 
    sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 4).map((res) => parseFloat(res.amount))) - sumArray(response.opening.filter(a=>a.type == 'Cashbook').map((res) => parseFloat(res.amount)))
    - sumArray(response.opening.filter(a=>a.type == 'COA' && a.fkey[0] == 3).map((res) => parseFloat(res.amount))) ;

    trialData.push({
      code: "411110",
      desc: "Creditors Control Account",
      debit: 0,
      credit: totalCred - sumArray(response.supplier.filter((a) => a.type == 2 && a.expense == 'None').map((res) => parseFloat(res.amount))),
    });
   
    totalCredits += totalCred - sumArray(response.supplier.filter((a) => a.type == 2).map((res) => parseFloat(res.amount)));

    setTrialBalanceData(trialData);
    setTotalDebit(totalDebits);
    setTotalCredit(totalCredits);
  };

  const sumArray = (arr) => arr.reduce((sum, num) => sum + num, 0);

  useEffect(() => {
    if(rdata.bills){
      fetchData();
      setLoading(false)
    }
  }, [rdata]);

  let tcred = 0.0
  let tdeb = 0.0

  return (
    <div className="w-full space-y-6">
      {
        loading?
        <>
         <div className='flex flex-col justify-center items-center h-64 w-full bg-white rounded-2xl border border-gray-100 shadow-sm'>
            <FaSpinner size={50} className="animate-spin text-blue-950 mb-4" />
            <p className="text-gray-600 text-lg">Loading trial balance...</p>
          </div>
        </>
        :
        <>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className=" px-6 py-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-blue-950 rounded-lg p-2">
                  <FaBalanceScale className="text-white text-xl" />
                </div>
                <div>
                  <h2 className='font-bold text-xl'>{allData.council[0]?.name.toUpperCase()}</h2>
                  <p className=" text-sm text-gray-600">Trial Balance Report</p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-gray-600 text-sm">
                <FaCalendarAlt />
                <span>From {formatDate(startDate)} to {formatDate(endDate)}</span>
              </div>
            </div>
            
            <div className="p-6">
              <div className="overflow-x-auto">
                <table className="table-auto w-full border-collapse">
                  <thead>
                    <tr className="bg-gradient-to-r from-blue-950 to-blue-800 text-white">
                      <th className="px-4 py-3 text-left font-semibold border-b border-blue-700">Code</th>
                      <th className="px-4 py-3 text-left font-semibold border-b border-blue-700">Description</th>
                      <th className="px-4 py-3 text-right font-semibold border-b border-blue-700">Debit</th>
                      <th className="px-4 py-3 text-right font-semibold border-b border-blue-700">Credit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trialBalanceData.sort((a, b) => a.code - b.code).map((entry, index) => {

                      const debit = entry.debit;
                      const credit = entry.credit;
                      let displayedDebit = 0;
                      let displayedCredit = 0;

                      // If both debit and credit have non-zero values
                      if (debit !== 0 && credit !== 0) {
                        const difference = debit - credit;
                        if (difference > 0) {
                          displayedDebit = difference; // Positive difference → debit
                        } else if (difference < 0) {
                          displayedCredit = Math.abs(difference); // Negative difference → credit
                        }
                        // If difference = 0, both remain 0
                      } else {
                        // Handle cases where only one side has a value
                        displayedDebit = Math.max(debit, -credit); // Debit or moved negative credit
                        displayedCredit = Math.max(credit, -debit); // Credit or moved negative debit
                      }

                      tdeb += displayedDebit
                      tcred += displayedCredit
                      return (
                        <tr
                          key={index}
                          className={`hover:bg-blue-50 transition-colors ${
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }`}
                        >
                          <td className="px-4 py-3 border-b border-gray-200 text-gray-700 font-mono text-sm">{entry.code}</td>
                          <td className="px-4 py-3 border-b border-gray-200 text-gray-700">{entry.desc}</td>
                          <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-green-700">
                            {displayedDebit > 0 ? formatToZMW(displayedDebit.toFixed(2)) : '-'}
                          </td>
                          <td className="px-4 py-3 border-b border-gray-200 text-right font-medium text-red-700">
                            {displayedCredit > 0 ? formatToZMW(displayedCredit.toFixed(2)) : '-'}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="bg-gradient-to-r from-gray-700 to-gray-800 text-white font-bold border-t-2 border-gray-400">
                      <th colSpan="2" className="px-4 py-3 text-left flex items-center gap-2">
                        <FaBalanceScale />
                        Total
                      </th>
                      <th className="px-4 py-3 text-right text-lg">
                        {formatToZMW(tdeb.toFixed(1))}
                      </th>
                      <th className="px-4 py-3 text-right text-lg">
                        {formatToZMW(tcred.toFixed(1))}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              
              <div className={`mt-6 p-4 rounded-lg flex items-center gap-3 ${
                Math.abs(tdeb - tcred) < 0.05 
                  ? "bg-green-50 border-2 border-green-200" 
                  : "bg-red-50 border-2 border-red-200"
              }`}>
                {Math.abs(tdeb - tcred) < 0.05 ? (
                  <>
                    <FaCheckCircle className="text-green-600 text-2xl" />
                    <div>
                      <p className="font-bold text-green-800 text-lg">Trial Balance is Balanced</p>
                      <p className="text-green-700 text-sm">Debits and Credits match</p>
                    </div>
                  </>
                ) : (
                  <>
                    <FaTimesCircle className="text-red-600 text-2xl" />
                    <div>
                      <p className="font-bold text-red-800 text-lg">Trial Balance is Not Balanced</p>
                      <p className="text-red-700 text-sm">Difference: {formatToZMW(Math.abs(tdeb - tcred).toFixed(2))}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      }
      
    </div>
  );
}
